package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.navigation.NavController
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.alphabetical
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_CHAPTER_IDENTIFYING_TASK
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_HALF_VERSE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_PARASHA_IDENTIFYING_TASK
import com.eladfinish.bible.contest.hide_people_names
import com.eladfinish.bible.contest.navigation.back.InterceptBackWhen
import com.eladfinish.bible.contest.navigation.popBackStackSafely
import com.eladfinish.bible.contest.pref_description_alphabetical
import com.eladfinish.bible.contest.pref_description_alphabetical_disabled
import com.eladfinish.bible.contest.pref_description_hide_people_names
import com.eladfinish.bible.contest.pref_description_hide_people_names_disabled
import com.eladfinish.bible.contest.pref_description_show_full_chapter
import com.eladfinish.bible.contest.random_approach
import com.eladfinish.bible.contest.screens.settings.ui.preferences.DropdownPreference
import com.eladfinish.bible.contest.screens.settings.ui.preferences.PreferenceSwitch
import com.eladfinish.bible.contest.show_full_chapter
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.flow.Flow

internal const val KEY_RANDOM_VERSE_REFRESH = "random_verse_refresh"

internal const val ENABLE_HALF_VERSE_DEFAULT = false
internal const val ENABLE_CHAPTER_IDENTIFYING_TASK = false
internal const val ENABLE_PARASHA_IDENTIFYING_TASK = false

@Composable
internal fun RandomVerseSettingsScreen(
    navController: NavController,
    settings: KeyValueSettings,
    getBooleanFlow: (key: String, defaultValue: Boolean) -> Flow<Boolean>,
    showRandomApproachExplanation: () -> Unit,
) {

    InterceptBackWhen {
        closeSettings(navController)
    }

    DropdownPreference(
        title = stringResource(SharedRes.strings.random_approach),
        key = "random_approach",
        entries = listOf("הגרל ספר, הגרל פרק, הגרל פסוק", "הגרל פרק, הגרל פסוק").toImmutableList(),
        entryValues = listOf(0, 1).map { it.toString() }.toImmutableList(),
        onClick = {
            showRandomApproachExplanation()
        },
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "הצגת חצי פסוק",
        key = KEY_ENABLE_HALF_VERSE,
        defaultValue = ENABLE_HALF_VERSE_DEFAULT,
        summaryOn = "יוצג חצי פסוק (רישא/סיפא)",
        summaryOff = "יוצג פסוק שלם",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.hide_people_names),
        key = "hide_people_names_switch",
        defaultValue = true,
        summaryOn = stringResource(SharedRes.strings.pref_description_hide_people_names),
        summaryOff = stringResource(SharedRes.strings.pref_description_hide_people_names_disabled),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.show_full_chapter),
        key = "show_full_chapter_switch",
        defaultValue = true,
        summaryOn = stringResource(SharedRes.strings.pref_description_show_full_chapter),
        summaryOff = stringResource(SharedRes.strings.pref_description_show_full_chapter),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.alphabetical),
        key = "alphabetical_switch",
        defaultValue = false,
        summaryOn = stringResource(SharedRes.strings.pref_description_alphabetical),
        summaryOff = stringResource(SharedRes.strings.pref_description_alphabetical_disabled),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "זיהוי פרק לאחר זיהוי ספר",
        key = KEY_ENABLE_CHAPTER_IDENTIFYING_TASK,
        defaultValue = ENABLE_CHAPTER_IDENTIFYING_TASK,
        summaryOn = "יש לזהות פרק לאחר שזוהה הספר",
        summaryOff = "יש לזהות ספר בלבד",
        settings = settings,
    )
    Divider()

    val enabled = getBooleanFlow(
        KEY_ENABLE_CHAPTER_IDENTIFYING_TASK,
        ENABLE_CHAPTER_IDENTIFYING_TASK,
    ).collectAsState(initial = false)

    PreferenceSwitch(
        title = "זיהוי פרשה אם הפסוק מהתורה",
        key = KEY_ENABLE_PARASHA_IDENTIFYING_TASK,
        defaultValue = ENABLE_PARASHA_IDENTIFYING_TASK,
        summaryOn = "יש לזהות פרשת שבוע",
        summaryOff = "יש לזהות פרק כרגיל",
        enabled = enabled.value,
        settings = settings,
    )
}


private fun closeSettings(
    navController: NavController,
) {
    navController.previousBackStackEntry
        ?.savedStateHandle
        ?.set(
            KEY_RANDOM_VERSE_REFRESH,
            true,
        )

    navController.popBackStackSafely()
}
